import defineTypes from 'helpers/defineTypes';
import * as api from 'api/timeslots';

// Action Types
const Types = defineTypes('mt/timeslots', ['FETCH', 'FETCHED', 'FETCH_FAILED']);

// Reducer
const initialState = { timeslots: [], isFetching: false };
export default (state = initialState, action) => {
  switch (action.type) {
    case Types.FETCH:
      return { ...state, isFetching: true };
    case Types.FETCHED:
      return { ...state, timeslots: action.payload };
    default:
      return state;
  }
};

// Action Types
export const fetch = marketerSessionId => async dispatch => {
  dispatch({ type: Types.FETCH });
  try {
    const json = await api.fetch(marketerSessionId);
    dispatch({ type: Types.FETCHED, payload: json });
  } catch (error) {
    dispatch({ type: Types.FETCH_FAILED, payload: { error } });
    throw error;
  }
};

// Selectors
export const getTimeslots = state => state.timeslots.timeslots;



// WEBPACK FOOTER //
// ./src/ducks/timeslots.js